import { RootState } from "../store";

export const getAdminPageSearch = (state: RootState) => state.adminPage.search;

export const getAdminPageOrganization = (state: RootState) =>
  state.adminPage.organization;
